import React from "react";
import { Link } from "react-router-dom";
import "./NotFound.css";

export default function NotFound() {
  return (
    <div className="not-found">
      <div className="container">
        <h1>404</h1>
        <p>Page not found</p>
        <Link to="/" className="nf-btn">Return Home</Link>
      </div>
    </div>
  );
}
